uniform vec2 uResolution;
uniform float uSize;
uniform vec3 uColorA;
uniform vec3 uColorB;
uniform float time;
uniform float shakeStrength;
attribute float flakeIndex;

#include ../includes/simplexNoise3d.glsl

varying vec3 vColor;

void main() {
    // Generate noise based on the original position
    float noise = simplexNoise3d(position * 0.3);
    noise = smoothstep(-1.0, 1.0, noise); // Normalize noise to 0-1

    // Mix colors based on noise
    vColor = mix(uColorA, uColorB, noise * 1.2);

    // Apply shake effect
    float shakeX = sin(position.x * 10.0 + time) * shakeStrength;
    float shakeY = sin(position.y * 10.0 + time * 1.5) * shakeStrength;
    float shakeZ = sin(position.z * 10.0 + time) * shakeStrength;
    // float shakeX = sin(flakeIndex * 10.0 + time) * shakeStrength;
    // float shakeY = sin(flakeIndex * 10.0 + time) * shakeStrength;
    // float shakeZ = sin(flakeIndex * 10.0 + time) * shakeStrength;
    vec3 shakenPosition = position + vec3(shakeX, shakeY, shakeZ);

    // Transform positions
    vec4 modelPosition = modelMatrix * vec4(shakenPosition, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;

    // Point size scaling
    gl_PointSize = uSize * uResolution.y;
    gl_PointSize *= (1.0 / -viewPosition.z);
}
